import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const transportService = {};

transportService.getTransports = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "maker_id",
    "maker_date",
    "checker_id",
    "checker_date",
    "tenant_code",
    "mod_no",
    "record_status",
    "auth_status",
    "name",
    "code",
    "cfg",
    "shipping_type",
    "group_code",
    "allowed_select_action_date",
    "tracking_url",
  ];

  return fetchV2({
    url: `${env.API_MSP}/transports`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

transportService.getAllTransports = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/transports`,
    method: "get",
    params: { ...params, sort: params.sort },
  });
};

// Detail Transport
transportService.detailTransport = ({ transportId }) => {
  return fetchV2({
    url: `${env.API_MSP}/transports/${transportId}`,
    method: "get",
  });
};

// Create Transport
transportService.createTransport = data => {
  return fetchV2({
    url: `${env.API_MSP}/transports`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Update Shipping Unit
transportService.updateTransport = ({ transportId = undefined, ...data }) => {
  return fetchV2({
    url: `${env.API_MSP}/transports/${transportId}`,
    method: "put",
    data,
  });
};

// Delete Shipping Unit
transportService.deleteTransport = transportId => {
  return fetchV2({
    url: `${env.API_MSP}/transports/${transportId}`,
    method: "delete",
  });
};

// transportOrderStatus
transportService.transportOrderStatus = ({
  listTransportId = [],
  fromTime,
  toTime,
  type,
}) => {
  return fetchV2({
    url: `${env.API_MSP}/dashboard`,
    method: "get",
    params: {
      listTransportId,
      fromTime,
      toTime,
      type,
    },
  });
};

// retryOrder
transportService.retryOrder = order_codes => {
  return fetchV2({
    url: `${env.API_MSP}/orders/retry-order`,
    method: "post",
    data: {
      order_codes,
    },
  });
};

// retryOrder
// transportService.getTransportGroup = params => {
//   return fetchV2({
//     url: `${env.API_MSP}/transport-groups`,
//     method: "get",
//     params,
//   });
// };
transportService.getTransportGroup = params => {
  const transformedParams = { ...params };
  if (transformedParams.record_status !== undefined) {
    transformedParams["filter[record_status]"] =
      transformedParams.record_status;
    delete transformedParams.record_status;
  }

  return fetchV2({
    url: `${env.API_MSP}/transport-groups`,
    method: "get",
    params: transformedParams,
  });
};

transportService.getListShippingType = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/transports/list-shipping-type`,
    method: "get",
    params,
  });
};

export default transportService;
